module.exports = __webpack_public_path__ + "img/5-2.6e711e5b.svg";